import { DefaultColorStyle, getDefaultColorTheme, type Editor } from "tldraw";

import { DEFAULT_INK } from "./cursorDot";

/** The hex the next stroke will draw with, per the editor's own palette. */
export function inkForNextShape(editor: Editor): string {
  try {
    const color = editor.getStyleForNextShape(DefaultColorStyle);
    const theme = getDefaultColorTheme({
      isDarkMode: editor.user.getIsDarkMode(),
    });
    return theme[color]?.solid ?? DEFAULT_INK;
  } catch {
    return DEFAULT_INK;
  }
}
